(() => {
  const config = document.querySelector('script[data-ufi-testing-fixes]');
  if (!config) return;
  const signedIn = config.dataset.ufiSignedIn === 'true';
  function quantityState(control) {
    if (!control) return;
    const input = control.querySelector('[data-quote-qty]');
    if (!input) return;
    const value = Number(input.value), min = Number(input.min || 1), step = Number(input.step || 1);
    const max = input.max === '' ? Infinity : Number(input.max);
    const last = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : Infinity;
    control.querySelector('[data-ufi-qty-adjust="-1"]').disabled = input.disabled || (input.value !== '' && value <= min);
    control.querySelector('[data-ufi-qty-adjust="1"]').disabled = input.disabled || (input.value !== '' && value >= last);
  }
  function updateAccountLinks() {
    if (!signedIn) return;
    const register = new URL(config.dataset.ufiRegisterUrl, location.origin);
    document.querySelectorAll('a[href]').forEach(link => {
      let url;
      try { url = new URL(link.getAttribute('href'), location.origin); } catch (_) { return; }
      if (url.href === new URL(config.dataset.ufiAccountUrl, location.origin).href && link.textContent.trim() === config.dataset.ufiAccountLabel) return;
      if (url.origin !== location.origin && url.origin !== register.origin) return;
      if (!/\/account\/register\/?$/.test(url.pathname) && url.href !== register.href) return;
      link.href = config.dataset.ufiAccountUrl;
      link.textContent = config.dataset.ufiAccountLabel;
      if (link.hasAttribute('aria-label')) link.setAttribute('aria-label', config.dataset.ufiAccountLabel);
      if (link.hasAttribute('title')) link.setAttribute('title', config.dataset.ufiAccountLabel);
    });
  }
  function refresh() {
    document.querySelectorAll('[data-ufi-quantity]').forEach(quantityState);
    updateAccountLinks();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-ufi-qty-adjust]');
    if (!button) return;
    event.preventDefault();
    const control = button.closest('[data-ufi-quantity]'), input = control?.querySelector('[data-quote-qty]');
    if (!input || input.disabled || button.disabled) return;
    if (input.value === '' || !Number.isFinite(Number(input.value))) input.value = input.min || '1';
    else if (button.dataset.ufiQtyAdjust === '1') input.stepUp();
    else input.stepDown();
    input.dispatchEvent(new Event('input', {bubbles:true}));
    input.dispatchEvent(new Event('change', {bubbles:true}));
    quantityState(control);
  });
  ['input', 'change'].forEach(type => document.addEventListener(type, event => {
    if (event.target.matches('[data-quote-qty]')) quantityState(event.target.closest('[data-ufi-quantity]'));
  }));
  refresh();
  document.addEventListener('shopify:section:load', refresh);
  new MutationObserver(refresh).observe(document.getElementById('root') || document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['href','min','max','step']});
})();
